import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'datatables.net-dt';
import { BlockUIService } from 'ng-block-ui';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-ordini-cms',
	templateUrl: './ordini-cms.component.html',
})
export class OrdiniCmsComponent implements OnInit {
	constructor(
		private api: ApiService,
		private auth: AuthService,
		private modalService: NgbModal,
		private blockUI: BlockUIService,
	) {}

	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: true, targets: 1, orderable: true },
			{ searchable: true, targets: 2, orderable: true },
			{ searchable: false, targets: 3, orderable: false },
		],
	};

	ordini = [];
	ordiniVisualizzati = [];

	anni = [];
	utente = this.auth.getUser();

	filtri = {
		anno: new Date().getFullYear(),
		daConfermare: true,
		parola: '',
	};

	modalRef: NgbModalRef;
	selectedOrder;
	jsonInAddTocart = {
		quantita: 0,
		codiceCommerciale: undefined,
	};
	addProductErrorMessage = false;

	listaCompany = [];

	ngOnInit() {
		for (let i = new Date().getFullYear(); i >= 2021; i--) {
			this.anni.push(i);
		}
		this.updateOrders();
		this.api.getListaCompany().subscribe(
			(res) => (this.listaCompany = res),
			() => alert('Errore nel recupero delle company'),
		);
	}

	filtra() {
		this.filtri.parola = this.filtri.parola.trim();
		this.ordiniVisualizzati = this.ordini.filter((o) => {
			return (
				o.utente.cliente.clientePlm.idBertazzoni.includes(this.filtri.parola) ||
				o.utente.cliente.codiceCliente.includes(this.filtri.parola) ||
				o.utente.username.includes(this.filtri.parola) ||
				`${o.id}`.includes(this.filtri.parola) ||
				o.prodottiCarrello.find((pc) => pc.nOrdineSimag?.includes(this.filtri.parola)) ||
				o.prodottiCarrello.find((pc) => pc.prodottoCommerciale.codiceCommerciale.includes(this.filtri.parola))
			);
		});
	}

	conferma(ordine) {
		this.api.confermaOrdine({ idOrdine: ordine.id, idCompany: ordine.idCompany || ordine.utente.company.id }).subscribe((res: any) => {
			if (res.esito === 'OK') {
				ordine.confermato = res.result.confermato;
				// Se l' ordine è stato spostato su un altra company, lo tolgo dalla lista
				if (res.result.company.id !== this.auth.getUser().company.id) {
					this.ordini.splice(this.ordini.indexOf(this.ordini.find((o) => o.id === ordine.id)), 1);
					this.ordiniVisualizzati.splice(this.ordiniVisualizzati.indexOf(this.ordiniVisualizzati.find((o) => o.id === ordine.id)), 1);
				} else {
					this.ordini.splice(this.ordini.indexOf(this.ordini.find((o) => o.id === ordine.id)), 1, res.result);
				}
			} else {
				alert("Errore nella conferma dell'ordine: " + res.descrizione);
			}
		});
	}

	apriModaleCompany(ordine, content) {
		console.log(ordine);
		this.selectedOrder = ordine;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	totaleOrdineAListino(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			if (item.prodottoCommerciale.listini[0]) {
				totale += item.quantita * item.prodottoCommerciale.listini[0].prezzoNetto;
			}
		});
		return totale;
	}

	totaleOrdine(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			totale += item.quantita * item.prezzoUnitarioOriginale;
		});
		return totale;
	}

	trovaNSimag(ordine) {
		const item = ordine.prodottiCarrello.find(({ nOrdineSimag }) => nOrdineSimag && nOrdineSimag !== '0' && nOrdineSimag.trim() !== '');
		return item ? item.nOrdineSimag : 'N/D';
	}

	aggiornaListini(contentAs400) {
		const connettore = this.auth.getUser().company.connettore;
		this.modalRef = this.modalService.open(contentAs400, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
		const $update = connettore === 'SAGEX3' ? this.api.importSageX3() : this.api.importAs400();
		$update.subscribe((res: any) => {
			if (res.esito === 'OK') {
				alert('Allineamento ERP completato.');
				this.modalRef.close();
				this.ngOnInit();
			} else {
				alert("Errore nell'allineamento ERP: " + res.descrizione);
			}
		});
	}

	editOrder(products, order) {
		this.selectedOrder = order;
		this.jsonInAddTocart.codiceCommerciale = undefined;
		this.jsonInAddTocart.quantita = 0;
		this.addProductErrorMessage = undefined;
		this.modalRef = this.modalService.open(products, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
	}

	stepQuantitaGenerico(mode: string) {
		if (this.jsonInAddTocart.quantita > 0 && mode === '-') {
			this.jsonInAddTocart.quantita--;
		}
		if (this.jsonInAddTocart.quantita < 100 && mode === '+') {
			this.jsonInAddTocart.quantita++;
		}
	}

	addProduct(enteredCode: string) {
		const productToAdd = {
			codiceCommerciale: enteredCode,
			idOrdine: this.selectedOrder.id,
			quantita: this.jsonInAddTocart.quantita,
		};

		this.api.addProductToOrder(productToAdd).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.selectedOrder = res.result;
			} else {
				this.addProductErrorMessage = res.descrizione;
			}
		});
	}

	saveProduct(product) {
		product.feEdit = false;
		this.editOrDeleteProduct(product, false);
	}

	deleteProduct(product) {
		this.selectedOrder.prodottiCarrello = this.selectedOrder.prodottiCarrello.filter((item) => item.id !== product.id);
		this.editOrDeleteProduct(product, true);
	}

	closeModal() {
		this.modalRef.close();
		this.updateOrders();
	}

	updateOrders() {
		this.api.getOrdiniFiltrati(this.filtri.anno, !this.filtri.daConfermare).subscribe((res) => {
			this.ordini = res.sort((a, b) => b.dataRegistrazioneOrdine - a.dataRegistrazioneOrdine).filter((o) => o.prodottiCarrello.length > 0);
			// Filtro i listini
			this.ordini.forEach((o) => {
				o.prodottiCarrello.forEach((item) => {
					item.prodottoCommerciale.listini = item.prodottoCommerciale.listini.filter((l) => l.cliente === o.utente.cliente.codiceCliente);
				});
			});
			this.ordiniVisualizzati = this.ordini;
			this.filtra();

			this.ordiniVisualizzati.map((order) => {
				order.feOpen = order.id === (this.selectedOrder && this.selectedOrder.id);
				return order;
			});

			this.filtra();
		});
	}

	editOrDeleteProduct(product, isDelete: boolean) {
		const productInfo = {
			delete: isDelete,
			idOrdine: this.selectedOrder.id,
			idRigaOrdine: product.id,
			prezzo: product.prezzoUnitarioOriginale,
			quantita: product.quantita,
		};
		this.api.modifyOrderRow(productInfo).subscribe((res) => {});
	}

	apriModalePriorita(ordine, content) {
		this.selectedOrder = ordine;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	savePriorita(modal) {
		const body = {
			idOrdine: this.selectedOrder.id,
			prioritario: this.selectedOrder.prioritario,
			listIdProdottoCarrello: this.selectedOrder.prodottiCarrello.filter((pc) => pc.prioritario).map((pc) => pc.id),
		};
		this.api.setPrioritaOrdine(body).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.ordini.splice(this.ordini.indexOf(this.ordini.find((o) => o.id === this.selectedOrder.id)), 1, res.result);
				this.ordiniVisualizzati.splice(this.ordiniVisualizzati.indexOf(this.selectedOrder), 1, res.result);
				modal.close();
			} else {
				alert('Errore: ' + res.descrizione);
			}
		});
	}

	getMessaggioPrioritario(ordine) {
		if (ordine.prioritario) {
			return 'The order has priority';
		} else if (ordine.prodottiCarrello.find((pc) => pc.prioritario)) {
			return 'Some orders do not have priority';
		} else {
			return '';
		}
	}
}
